import React, { useEffect, useState } from "react";
import { getSizes, deleteSize } from "../../../api/sizeService";
import { FaPlus, FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { getErrorMessage } from "../../../utils/errorHandler";

export default function SizeList() {
  const [sizes, setSizes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("desc");
  const navigate = useNavigate();

  const fetchSizes = async () => {
    try {
      setLoading(true);

      const response = await getSizes({ search, sort });
      setSizes(response?.data || response?.sizes || []);
    } catch (error) {
      console.error("Error fetching sizes:", error);
      alert(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSizes();
  }, [search, sort]);

  const handleDelete = async (id) => {
    try {
      await deleteSize(id);

      fetchSizes();
    } catch (error) {
      console.error(error);
      alert(getErrorMessage(error));
    }
  };

  return (
    <div className="container-fluid p-4 np-size-options-page">
      <div className="card p-3">
        <div className="d-flex align-items-center justify-content-end pb-3 gap-2">
          <input
            type="text"
            className="form-control"
            style={{ width: "220px" }}
            placeholder="Search size..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <select
            className="form-select border-0"
            value={sort}
            onChange={(e) => setSort(e.target.value)}
            style={{ width: "100px" }}
          >
            <option value="asc">ASC</option>
            <option value="desc">DESC</option>
          </select>

          <button
            className="btn btn-primary d-flex align-items-center gap-2"
            onClick={() => navigate("/size/add")}
          >
            <FaPlus />
            Add Size
          </button>
        </div>

        {loading ? (
          <div className="text-center py-3">Loading...</div>
        ) : (
          <table className="table table-bordered table-hover">
            <thead className="bg-light">
              <tr>
                <th className="text-dark fw-bold">#</th>
                <th className="text-dark fw-bold">Size Name</th>
                <th className="text-dark fw-bold">Size value</th>
                <th className="text-dark fw-bold">Status</th>
                <th className="text-dark fw-bold">Actions</th>
              </tr>
            </thead>

            <tbody>
              {sizes.length > 0 ? (
                sizes.map((size, index) => (
                  <tr key={size._id}>
                    <td>{index + 1}</td>

                    <td>{size.name}</td>

                    <td>{size.value}</td>

                    <td>
                      <span
                        className={`badge ${size.status === "ACTIVE" ? "bg-success" : "bg-danger"}`}
                      >
                        {size.status}
                      </span>
                    </td>
                    <td className="text-center d-flex justify-content-center gap-2">
                      <button
                        className="btn btn-sm np-table-action-btn"
                        onClick={() =>
                          navigate(`/size/view/${size.name}`, {
                            state: { sizeId: size._id },
                          })
                        }
                      >
                        <FaEye />
                      </button>

                      <button
                        className="btn btn-sm np-table-action-btn"
                        onClick={() =>
                          navigate(`/size/edit/${size.name}`, {
                            state: { sizeId: size._id },
                          })
                        }
                      >
                        <FaEdit />
                      </button>

                      <button
                        className="btn btn-sm np-table-action-btn"
                        onClick={() => handleDelete(size._id)}
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No sizes found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}